// ===============================================
// 🚀 CONFIGURACIÓN DEL BACKEND
// Configuración centralizada del cliente
// ===============================================

// Detectar entorno
const isProduction = process.env.NODE_ENV === 'production';
const isDevelopment = !isProduction;

const BACKEND_CONFIG = {
  // 🌐 Backend de verdad: vive en el proyecto aparte `IGNIA-backend`,
  // NO en este despliegue (que solo sirve el build estático de React). Aquí
  // están /api/correo/*, /api/upload-plantilla y el resto de subidas, por eso
  // no se usa window.location.origin. Se puede apuntar a otro host con
  // REACT_APP_CORREO_API_URL (por ejemplo, para probar en local).
  BACKEND_API_URL:
    process.env.REACT_APP_CORREO_API_URL ||
    (isProduction
      ? 'https://api.agpsoluciones.com'
      : 'http://localhost:5000'),

  // Configuración de archivos
  LIMITS: {
    IMAGE_MAX_SIZE: 15 * 1024 * 1024, // 15MB
    DOCUMENT_MAX_SIZE: 50 * 1024 * 1024, // 50MB
    ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'],
    ALLOWED_DOCUMENT_TYPES: [
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel'
    ]
  },

  // Configuración de Firebase
  FIREBASE_INTEGRATION: {
    USE_FIREBASE_STORAGE: false, // Los archivos van al backend, no a Firebase Storage
    USE_FIREBASE_AUTH: true,     // Mantener Firebase Auth
    USE_FIRESTORE: true          // Mantener Firestore para datos
  }
};

// Función para obtener la configuración actual
export const getBackendConfig = () => ({
  ...BACKEND_CONFIG,
  environment: isProduction ? 'production' : 'development',
  isProduction,
  isDevelopment
});

// Función de validación de archivos
export const validateFile = (file, type = 'image') => {
  const config = getBackendConfig();

  if (type === 'image') {
    const isValidType = config.LIMITS.ALLOWED_IMAGE_TYPES.includes(file.type);
    const isValidSize = file.size <= config.LIMITS.IMAGE_MAX_SIZE;

    return {
      valid: isValidType && isValidSize,
      errors: [
        ...(!isValidType ? [`Tipo no permitido. Permitidos: ${config.LIMITS.ALLOWED_IMAGE_TYPES.join(', ')}`] : []),
        ...(!isValidSize ? [`Tamaño máximo: ${(config.LIMITS.IMAGE_MAX_SIZE / (1024 * 1024)).toFixed(1)}MB`] : [])
      ]
    };
  }

  if (type === 'document') {
    const isValidType = config.LIMITS.ALLOWED_DOCUMENT_TYPES.includes(file.type);
    const isValidSize = file.size <= config.LIMITS.DOCUMENT_MAX_SIZE;

    return {
      valid: isValidType && isValidSize,
      errors: [
        ...(!isValidType ? ['Tipo no permitido. Permitidos: PDF, Word, Excel'] : []),
        ...(!isValidSize ? [`Tamaño máximo: ${(config.LIMITS.DOCUMENT_MAX_SIZE / (1024 * 1024)).toFixed(1)}MB`] : [])
      ]
    };
  }

  return { valid: false, errors: ['Tipo de archivo no reconocido'] };
};

// Exportar configuración por defecto
export default BACKEND_CONFIG;
